import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarWrapper from '../_core/Atoms/SnackbarContent'
import PropTypes from 'prop-types'

const Toast = props => {
  const [open, setOpen] = React.useState(true)

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpen(false)
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <SnackbarWrapper onClose={handleClose} {...props} />
    </Snackbar>
  )
}

Toast.defaultProps = {
  id: 'Toast',
  variant: 'error',
  message: 'Sample toast message'
}

Toast.propTypes = {
  /** Guidelines: https://rfg-projects.atlassian.net/wiki/spaces/RP/pages/569475249/RFG+Platform+-+QA+ID+Standards */
  id: PropTypes.string.isRequired,
  /** Selection of different variant for different usage. **/
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired
}

export default Toast
